import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ListItem } from 'material-ui/List';
import Checkbox from 'material-ui/Checkbox';

export default class ServiceListItem extends Component {

  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number,
    time: PropTypes.number,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChecked: PropTypes.func,
  };

  static defaultProps = {
    price: 0,
    time: 0,
    checked: false,
    disabled: false,
    onChecked: () => {},
  };

  shouldComponentUpdate(nextProps) {
    // Only update if "checked" has changed.
    // /!\ We DO NOT check for other props. It means once loaded, you cannot change
    // service's properties. If you need to, update this function
    if (this.props.checked !== nextProps.checked || this.props.disabled !== nextProps.disabled)
      return true;
    else
      return false;
  }

  handleChecked = () => {
    this.props.onChecked();
  }

  render() {
    let secondaryText = (this.props.showPrices) ? `${this.props.price}€ - ${this.props.time}min.` : `${this.props.time}min.`;

    return (
      <ListItem
        primaryText={this.props.name}
        secondaryText={secondaryText}
        leftCheckbox={(
          <Checkbox
            checked={this.props.checked}
            onClick={this.handleChecked}
            disabled={!this.props.checked && this.props.disabled && this.props.coiffure}
          />
        )}
        rightAvatar={<div></div>}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ServiceListItem.js